<template>
  <div id="dashboard" v-if="user">
    <companiesList
      id="companiesList"
      @selectCompany="selectCompany"
    />
    <companyDetail
      id="companyDetail"
      v-if="activeCompany"
      :cid="activeCompany"
      :activeCampaign="activeCampaign"
      :activeApplication="activeApplication"
      @selectCampaign="selectCampaign"
      @selectApplication="selectApplication"
    />
    <campaignDetail
      id="campaignDetail"
      v-if="activeCampaign"
      :cid="activeCampaign"
    />
    <applicationDetail
      id="campaignDetail"
      v-if="activeApplication"
      :aid="activeApplication"
    />
    <div id="logout" @click="signOut">{{user.displayName}} - logout</div>
  </div>
</template>

<script>
import firebase from 'firebase';

import companiesList from './companiesList.vue'
import companyDetail from './companyDetail.vue'
import campaignDetail from './campaignDetail.vue'
import applicationDetail from './applicationDetail.vue'
export default {
  name: 'dashboard',
  data:function(){
    return {
      activeCompany:null,
      activeCampaign:null,
      activeApplication:null,
      user:firebase.auth().currentUser,
    }
  },
  components:{
    companiesList,
    companyDetail,
    campaignDetail,
    applicationDetail,
  },
  methods:{
    selectCompany(id){
      this.activeCompany = id;
      this.activeCampaign = null;
      this.activeApplication = null;
    },
    selectCampaign(id){
      this.activeCampaign = id;
      this.activeApplication = null;
    },
    selectApplication(id){
      this.activeApplication = id;
      this.activeCampaign = null;
    },
    signOut(){
      firebase.auth().signOut().then(() => {
        this.$router.replace({name:'login'})
      }).catch((error) => {
        console.log(error);
      });
    }
  }
}
</script>
<style scoped>
#dashboard{
  min-height: 100vh;
  background: #e5e5e5;
}
#companyDetail,
#campaignDetail,
#companiesList{
  height: 100vh;
  width:33.33%;
  min-width: 200px;
  background: #fff;
  position: absolute;
  float:left;
}
#companiesList{
  height: calc(100vh - 40px) !important;
}
#companyDetail{
  margin-left:33.33%;
  background:#eee;
}
#campaignDetail{
  margin-left:66.66%;
  background:#e5e5e5;
}
#logout{
  position: fixed;
  left:0;
  bottom:0;
  background-color: #333;
  color:#fff;
  height:40px;
  line-height:40px;
  width:33.33%;
  text-align: center;
  cursor:pointer;
}
#logout:hover{
  background-color: #222;
}
</style>